import { Component, ViewEncapsulation } from "@angular/core";
import _ from "lodash";
import { DbQueryService } from "@/shared/db-query.service";
import { AddonStationProcessedKpi } from "app/model/entities/-chart-classes";
import { KpiRangeWidgetBase } from "./kpi-widget-base";

@Component({
  selector: "app-process-station-units-kpi",
  templateUrl: "./process-station-units-kpi.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProcessStationUnitsKpiComponent extends KpiRangeWidgetBase<AddonStationProcessedKpi[]> {
  stations: AddonStationProcessedKpi[] = [];
  /** Distinct units - a unit that went through two stations counts once at each, so the rows do not sum to this. */
  totalUnitCount = 0;

  constructor(private dbQueryService: DbQueryService) {
    super();
  }

  protected fetch(fromDate: string, toDate: string) {
    return this.dbQueryService.getAddonStationProcessedKpi(fromDate, toDate, this.includedAccountIds);
  }

  protected apply(rows: AddonStationProcessedKpi[]) {
    this.stations = _.sortBy(rows, (x) => x.defaultPriorityOrder);
    this.totalUnitCount = _.first(rows)?.totalUnitCount ?? 0;
  }
}
